import React from "react";
import styles from "./Tags.module.css";
import { formatDate } from "./FilterModal"; 

const Tags = ({ filterStatus, filterRange, onStatusRemove, onDateRemove }) => {
  const safeStatus = Array.isArray(filterStatus) ? filterStatus : [];
  const { from, to } = filterRange || {};
  const hasDate = from && to;

  const formatStatus = (str) => {
    if (!str) return '';
    const words = str.toLowerCase().split('_');
    return words[0].charAt(0).toUpperCase() + words[0].slice(1) + ' ' + words.slice(1).join(' ');
  };
  
  return (
    <div className={styles.tagsContainer}>
      {hasDate && (
        <div className={styles.tag}>
          {formatDate(from)} - {formatDate(to)}
          <span
          role="button"
          tabIndex={0}
          aria-label={`Remove Date`}
          className={styles.remove}
          onClick={() => onDateRemove(onDateRemove)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onDateRemove();
            }
          }}
        >
          ×
        </span>
        </div>
      )}
      {safeStatus.map((status) => (
        <div key={status} className={styles.tag}>
        {formatStatus(status)}
        <span
          role="button"
          tabIndex={0}
          aria-label={`Remove status ${status}`}
          className={styles.remove}
          onClick={() => onStatusRemove(status)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              onStatusRemove(status);
            }
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path d="M1.5 1.79032L10.5 10.5M1.5 10.2097L10.5 1.5" stroke="#222222"/>
          </svg>
        </span>
      </div>      
      ))}
    </div>
  );
};

export default Tags;